import { cva } from 'class-variance-authority';

/**
 * Styles for Header component
 */
export const headerStyles = cva(
  [
    'bg-primary',
    // Mobile: 8px top/bottom, 16px left/right
    'py-2',
    'px-4',
    // Tablet: 8px top/bottom, 32px left/right
    'md:py-2',
    'md:px-8',
    // Desktop: 16px top/bottom, 32px left/right
    'lg:py-4',
    'lg:px-8',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

export const headerSeparatorStyles = cva(
  [
    'w-full',
    'h-2', // 0.5rem height
    'bg-[#35ccba]', // Teal color from Figma
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);
